import React, { useState, useEffect } from "react";
import axios from "axios";
import {Tooltip, Card, CardContent, Typography, Grid, Box, TextField, MenuItem, Select, InputLabel, FormControl, Slider, IconButton, Button, skeleton, Avatar } from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import StarIcon from '@mui/icons-material/Star';  // Import Star icon for rating
import FilterListIcon from '@mui/icons-material/FilterList'; // Import the filter icon
import VisibilityIcon from '@mui/icons-material/Visibility';
import avatar from './default-avatar.png'
import ShareIcon from '@mui/icons-material/Share';
import { AccessTime } from '@mui/icons-material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'; // Import the rupee icon
import Header1 from "../Header/Header1";

const API_URL = process.env.REACT_APP_API_URL;



function AdminViewAllUsers({ userId, onLogout }) {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);

  
  const [sections, setSections] = useState([]);
  const [subsections, setSubsections] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [areaOfInterest, setAreaOfInterest] = useState([])
  const [timeOfAvailability, setTimeOfAvailability] = useState([
        "Early Morning (12:00 AM - 9:00 AM)",
        "Morning (9:00 AM - 12:00 PM)",
        "Afternoon (12:00 PM - 3:00 PM)",
        "Evening (3:00 PM - 6:00 PM)",
        "Night (6:00 PM - 12:00 AM)",
        "Weekend (Saturday - Sunday)",
        "Weekdays (Monday - Friday)",
        "All the Time (24/7)",
        "Instantly Available (Right now)",
        "During Holidays (Public/Company holidays)",
        "Only during Day (9:00 AM - 6:00 PM)",
        "Only during Night (6:00 PM - 12:00 AM)",
        "Currently Not Available"
  ])
  const [filters, setFilters] = useState({
    rating: 0,
    date: "",
    time: "",
    cost: [0, 500], // Cost range slider
    language: "",
    duration: [0, 120], // Duration range slider in minutes
    areaOfInterest: "",
    timeOfAvailabilty: ""
  });

  const [page, setPage] = useState(1);  // Start with page 1
  const [allFetched, setAllFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

 
  const buildQuery = () => {
    let query = `?user_id=${userId}&page=${page}`;
    if (filters.areaOfInterest) query += `&areaOfInterest=${filters.areaOfInterest}`;
    if (filters.rating) query += `&rating=${filters.rating}`;
    if (filters.language) query += `&language=${filters.language}`;
    if (filters.timeOfAvailabilty) query += `&timeOfAvailability=${filters.timeOfAvailabilty}`;

    return query;
  };


  const fetchData = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`${API_URL}/list-all-users-admin/${buildQuery()}`);

      if (response.data.length === 0) {
        setAllFetched(true);  // Stop fetching if no new data
      } else {
       
        setSections((prevSections) => {
          // Create a Set of existing section user_ids for faster lookup
          const existingSectionIds = new Set(prevSections.map((section) => section.user_id));
        
          // Filter new sections that aren't already in the existing sections by user_id
          const newSections = response.data.filter(
            (newSection) => !existingSectionIds.has(newSection.user_id)
          );
                
          return [...prevSections, ...newSections];
        });
        
        
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    setPage(1);
    setAllFetched(false);
    setSections([]);
  }, [filters]);

  // Fetch data on page change or when filters change
  useEffect(() => {
    if (!allFetched) {
      fetchData();
    }
  }, [filters, userId, page]); // Dependencies include page and filters

  // Handle scroll event to detect when the user has scrolled to the bottom
  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    if (windowHeight + scrollPosition >= documentHeight - 1 && !loading && !allFetched) {
      setPage((prevPage) => prevPage + 1);  // Increment the page to load next data
    }
  };

  // Add event listener for scroll on component mount and cleanup on unmount
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [loading, allFetched]);

  const extractLanguages = (data) => {
    const allLanguages = new Set();

    data.forEach(item => {
      allLanguages.add(item.name);
    });

    setLanguages([...allLanguages]);
  };


  const navigate = useNavigate();

  const allCards = sections

  const handleFilterChange = (event, filterType) => {
    setFilters({
      ...filters,
      [filterType]: event.target.value,
    });
  };
  const handleSliderChange = (event, newValue, filterType) => {
    if (Array.isArray(newValue)) {
      setFilters({
        ...filters,
        [filterType]: newValue,
      });
    } else {
      // For single value filters
      setFilters({
        ...filters,
        [filterType]: newValue,
      });
    }
  };

  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await fetch(`${API_URL}/list_sections_and_subsections/`);
        const data = await response.json();
        const formattedSections = Object.keys(data.sections).map((key) => ({
          section_id: data.sections[key].section_id,
          section_name: key,
          subsections: data.sections[key].subsections || [],
        }));
        setCategories(formattedSections);
        extractLanguages(data.languages);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchSections();
  }, []);

  useEffect(() => {
    const fetchAreaOfInterest = async () => {
        try {
            const response = await axios.get(`${API_URL}/api/areas-of-interest/`);
            setAreaOfInterest(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    fetchAreaOfInterest();
}, []); 


  const handleSearch = (result) => {
    setSections(result)
    // setData(result)
  }

  const handleClearFilters = () => {
    setFilters({
      rating: 0,
      date: "",
      time: "",
      cost: [0, 500], // Cost range slider
      language: "",
      duration: [0, 120], // Duration range slider in minutes
      areaOfInterest: "",
      timeOfAvailabilty: ""
    })
    setAllFetched(false);

  }

  const handleSectionChange = (event) => {
    const selectedSectionId = event.target.value;
    setFilters((prev) => ({
      ...prev,
      sectionId: selectedSectionId,
      subsectionId: ''  // Reset subsection when section changes
    }));

    // Find the subsections corresponding to the selected section
    const selectedSection = categories.find(
      (category) => category.section_id === selectedSectionId
    );
    setSubsections(selectedSection ? selectedSection.subsections : []);
  };

  const handleSubsectionChange = (event) => {
    setFilters((prev) => ({
      ...prev,
      subsectionId: event.target.value
    }));
  };

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <Box sx={{ padding: "1rem", backgroundColor: "#11111", minHeight: "100vh", ml: 5, mt: 5}}>
      <Header1 userId={userId} page_name="request_user" onSearch={handleSearch} onLogout={onLogout} />
    
      <Tooltip title="Filter Panel" placement="left">
      <IconButton
        onClick={() => setShowFilters(!showFilters)}
        sx={{
          color: "#ffffff",
          position: "fixed",  // Absolutely position it within the parent box
          top: "70px",            // Add some spacing from the top
          right: "10px",          // Add some spacing from the right edge
          zIndex: 20,
          "&:hover": {
            color: "#1E90FF",  // Icon color on hover
          },
        }}
      >
        <FilterListIcon />
      </IconButton></Tooltip>
      {/* Filter Panel - Initially Hidden */}
      {showFilters && (
        <Box sx={{
          position: "fixed",
          top: "60px",
          right: "0",
          width: "300px",
          height: "100%",
          backgroundColor: "#000000",
          padding: "3rem",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.4)",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          borderRadius: "8px",
          zIndex: "10"
        }}>

          <FormControl sx={{ width: "100%", marginBottom: "1rem" }}>
            <InputLabel sx={{ color: "#ffffff", letterSpacing: 2, }}>Areas of Interest</InputLabel>
            <Select
              value={filters.areaOfInterest}
              label="area of interest"
              onChange={(e) => handleFilterChange(e, "areaOfInterest")}
              sx={{
                backgroundColor: "#2222",
                color: "#ffffff",
                letterSpacing: 2,
                "& .MuiInputBase-root": {
                  color: "#ffffff",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2222",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1E90FF",
                }
              }}
            >
              <MenuItem value="" sx={{letterSpacing: 2,}}>Select area of interest</MenuItem>
              {areaOfInterest.map((interest, index) => (
                <MenuItem key={index} value={interest.name} sx={{letterSpacing: 2,}}>
                  {interest.name}
                </MenuItem>
              ))}
              {/* Add other languages here */}
            </Select>
          </FormControl>

          <FormControl sx={{ width: "100%", marginBottom: "1rem" }}>
            <InputLabel sx={{ color: "#ffffff", letterSpacing: 2, }}>Time of Availability</InputLabel>
            <Select
              value={filters.timeOfAvailabilty}
              label="Time of Availabilty"
              onChange={(e) => handleFilterChange(e, "timeOfAvailabilty")}
              sx={{
                backgroundColor: "#2222",
                color: "#ffffff",
                letterSpacing: 2,
                "& .MuiInputBase-root": {
                  color: "#ffffff",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2222",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1E90FF",
                }
              }}
            >
              <MenuItem value="" sx={{letterSpacing: 2,}}>Select time of availability</MenuItem>
              {timeOfAvailability.map((availability, index) => (
                <MenuItem key={index} value={availability} sx={{letterSpacing: 2,}}>
                  {availability}
                </MenuItem>
              ))}
              {/* Add other languages here */}
            </Select>
          </FormControl>

          <FormControl sx={{ width: "100%", marginBottom: "1rem" }}>
            <InputLabel sx={{ color: "#ffffff", letterSpacing: 2, }}>Rating</InputLabel>
            <Select
              value={filters.rating}
              label="Rating"
              onChange={(e) => handleFilterChange(e, "rating")}
              sx={{
                backgroundColor: "#2222",
                color: "#ffffff",
                letterSpacing: 2,
                "& .MuiInputBase-root": {
                  color: "#ffffff",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2222",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1E90FF",
                }
              }}
            >
              {[0, 1, 2, 3, 4, 5].map((rating) => (
                <MenuItem key={rating} value={rating} sx={{letterSpacing: 2,}}>
                  {rating}+
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box sx={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>


          </Box>
          {/* Language Filter */}
          <FormControl sx={{ width: "100%", marginBottom: "1rem" }}>
            <InputLabel sx={{ color: "#ffffff", letterSpacing: 2, }}>Language</InputLabel>
            <Select
              value={filters.language}
              label="Language"
              onChange={(e) => handleFilterChange(e, "language")}
              sx={{
                backgroundColor: "#2222",
                color: "#ffffff",
                letterSpacing: 2,
                "& .MuiInputBase-root": {
                  color: "#ffffff",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2222",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1E90FF",
                }
              }}
            >
              <MenuItem value="" sx={{letterSpacing: 2,}}>Select Language</MenuItem>
              {languages.map((lang, index) => (
                <MenuItem key={index} value={lang} sx={{letterSpacing: 2,}}>
                  {lang}
                </MenuItem>
              ))}
              {/* Add other languages here */}
            </Select>
          </FormControl>

          <Box sx={{ }}>
            <Button
              onClick={handleClearFilters}
              variant="outlined"
              sx={{
                width: "100%",
                color: "#1E90FF",
                letterSpacing: 2,
                borderColor: "#1E90FF",
                "&:hover": {
                  backgroundColor: "#1E90FF",
                  color: "#fff"
                }
              }}
            >
              Clear Filters
            </Button>
          </Box>

        </Box>
      )}
      {/* Filter Bar */}
      <Box sx={{ marginRight: showFilters ? "75px" : "0", transition: "margin-right 0.3s" }}>
        {/* Cards Section */}
        <Grid
          container
          spacing={2}
          sx={{
            marginTop: showFilters ? "2px" : "0", // Adjust the cards' position when filters are shown
            width: showFilters ? "calc(100% - 200px)" : "100%", // Dynamically adjust width when filter is shown
            marginRight: "auto", // Center the grid container
            justifyContent: "center", // Center the grid content
            display: "flex", // Ensure flexbox layout is used
            flexWrap: "wrap", // Allow wrapping for responsive design
          }}
        >
          {allCards.map((card, cardIndex) => (
            <Grid
              item
              xs={12} // 12 columns on extra small screens (1 card per row)
              sm={showFilters ? 12 : 6}  // 12 columns on small screens when filters are open (1 card per row), else 2 cards per row
              md={showFilters ? 6 : 4}   // 6 columns on medium screens when filters are open (2 cards per row), else 3 cards per row
              lg={showFilters ? 4 : 3}   // 4 columns on large screens when filters are open (3 cards per row), else 4 cards per row
              key={cardIndex}
            >
              {/* <Link to={`/request-user-tab-details/${card.user_id}`} style={{ textDecoration: "none" }}> */}
              <Link to={`/user-profile-admin-view/${card.user_id}`} style={{ textDecoration: "none" }}>
                <Box
  sx={{
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#3333",
    borderRadius: "15px",
    overflow: "hidden",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
    transition: "transform 0.3s, box-shadow 0.3s",
    textDecoration: "none",
    color: "inherit",
    width: "100%",
    height: "350px",  // Fixed height for consistent size
    minHeight: "350px",  // Ensures minimum height remains consistent
    minWidth: "200px",  // Set a minimum width for the boxes
    borderColor: "#5555",
    padding: "10px",
    "&:hover": {
      transform: "translateY(-5px)",
      border: "1px solid transparent", // Transparent border for hover effect
      backgroundClip: "padding-box",
      borderImage: "linear-gradient(45deg, #00bfff, #ff00ff) 1",
      boxShadow: "0 15px 25px rgba(0, 0, 0, 0.15)",
    },
    
    // Responsive styling
    "@media (max-width: 1440px)": {
      height: "auto", // Let the height adjust for medium screens
      minHeight: "300px",
      minWidth: "280px", // Increase min-width slightly for screens between 1200px and 1440px
      padding: "9px", // Adjust padding for medium-large screens
    },
    "@media (max-width: 1200px)": {
      height: "auto", // Let the height adjust for medium screens
      minHeight: "300px",
      minWidth: "250px", // Slightly larger min-width for medium screens
      padding: "8px", // Adjust padding for medium screens
    },
    "@media (max-width: 768px)": {
      flexDirection: "column", // Stack elements vertically on tablets
      height: "auto", // Allow flexibility for smaller screens
      minHeight: "250px", // Adjust min-height for smaller screens
      minWidth: "220px", // Reduce min-width slightly for smaller screens
      padding: "6px", // Reduce padding on smaller screens
    },
    "@media (max-width: 480px)": {
      padding: "5px", // Further reduce padding on very small screens
      height: "auto", // Allow flexibility on very small screens
      minHeight: "220px", // Adjust min-height for very small screens
      minWidth: "250px", // Further reduce min-width for small screens
    },
  }}
>
                  <Box
                    sx={{
                      padding: "15px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "100%",
                    }}
                  >
                    {/* Section Name */}
                    <Grid
                      container
                      spacing={1}
                      sx={{
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#121212",
                        height: "60px",
                        display: "flex",
                        flexDirection: "column",
                        textAlign: "center",
                        borderRadius: "8px",
                        padding: "12px",
                        marginBottom: "15px",
                      }}
                    >
                      
                      <Typography
                        variant="h8"
                        component="h1"
                        sx={{
                          fontSize: { xs: "0.7rem", sm: "0.75rem", md: "0.82rem" }, // Font size adjustment for different screen sizes
                          fontWeight: 300,
                          color: "white",
                          letterSpacing: 2,
                          whiteSpace: "normal", // Ensures text wraps if needed
                          wordWrap: "break-word", // Break words if they are too long
                          width: "100%", // Ensure it takes the full width
                          fontStyle: "italic",
                          // Adjusting padding and line-height for better readability on smaller screens
                          padding: { xs: "0 8px", sm: "0 12px", md: "0 16px" }, // Padding for better spacing
                          lineHeight: { xs: "1.2", sm: "1.3", md: "1.4" }, // Adjusting line height for different screen sizes
                        }}
                      >
                        {Array.isArray(card.areas_of_interest) && card.areas_of_interest.length > 0
  ? card.areas_of_interest.join(', ').length > 50
    ? card.areas_of_interest.join(', ').slice(0, 50) + "..."
    : card.areas_of_interest.join(', ')
  : 'N/A'}

                        
                      </Typography>

                    </Grid>

                 

                    {/* Teacher Image and Name */}
                    <Grid container spacing={1} sx={{ justifyContent: "center", alignItems: "center" }}>
                      {/* Teacher Image */}
                      <Grid item xs={3} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <Avatar sx={{
        width: 50,
        height: 50,
        // mr: 2,
      }} src={`${API_URL}${card.image}` || '/default-avatar.png'} alt={card.name || 'User'} />
                    

                      </Grid>
                      {/* Teacher Name */}
                      <Grid item xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: { xs: "0.9rem", sm: "1rem", md: "1.2rem" }, // Responsive font size
                            color: "white",
                            letterSpacing: 3,
                            textAlign: "center", // Keeps text centered across all screen sizes
                            marginTop: { xs: "3px", sm: "5px", md: "5px" }, // Adjust top margin for different screen sizes
                            marginBottom: { xs: "3px", sm: "5px", md: "5px" }, // Optional: Adjust bottom margin for consistency
                            paddingX: { xs: "8px", sm: "12px", md: "16px" }, // Add horizontal padding on smaller screens
                            // '&:hover': {
                            //   color: '#1E90FF', // Hover color
                            // },
                          }}
                        >
                          {card.name.length > 20 ? `${card.name.slice(0, 20)}...` : card.name}

                        </Typography>
                      </Grid>
                     
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" }, // Responsive font size
                        fontWeight: 200,
                        letterSpacing: 2,
                        textAlign: "center", // Keeps text centered on all screen sizes
                        color: "white",
                        fontStyle: "italic", // Italicized text
                        mt: { xs: 1, sm: 0.1, md: 0.1 }, // Adjust top margin for better spacing on smaller screens
                        mb: { xs: 1, sm: 1, md: 1 }, // Adjust bottom margin for consistency
                        px: { xs: 2, sm: 1, md: 1 }, // Horizontal padding to avoid text sticking to edges on smaller screens
                      }}
                    >
                      Current Role: {card.role.length > 30 ? `${card.role.slice(0, 30)}...` : card.role}

                    </Typography>
                      <Typography
                      variant="h6"
                      sx={{
                        fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" }, // Responsive font size
                        fontWeight: 200,
                        letterSpacing: 2,
                        textAlign: "center", // Keeps text centered on all screen sizes
                        color: "white",
                        fontStyle: "italic", // Italicized text
                        mt: { xs: 1, sm: 0.1, md: 0.1 }, // Adjust top margin for better spacing on smaller screens
                        mb: { xs: 1, sm: 1, md: 1 }, // Adjust bottom margin for consistency
                        px: { xs: 2, sm: 1, md: 1 }, // Horizontal padding to avoid text sticking to edges on smaller screens
                      }}
                    >
                      {card.about.length > 50 ? `${card.about.slice(0, 50)}...` : card.about}

                    </Typography>
                      
                    

                                            <Grid container justifyContent="center" spacing={2}>
                        
                      </Grid>
                    </Grid>
                  </Box>
                </Box>

              </Link>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
export default AdminViewAllUsers;